import React from 'react'
import { useMemo } from 'react';
import {
    MaterialReactTable,
    useMaterialReactTable,
} from 'material-react-table';

import SvgPanel from '../components/PanelFigura/SvgPanel';
import { formatCreateP10 } from "../components/helpers/formatCreateP10";

export default function TableCruds({ datos, loadingData = true }) {
    const columns = useMemo(
        () => [
            { accessorFn: (row) => row.user ?? row.User ?? '', id: 'user', header: 'Usuario',},
            { accessorKey: 'updateTime', header: 'Fecha actualización' },
            { accessorKey: 'namePanel', header: 'Panel' },
        ], [],
    );


    const table = useMaterialReactTable({
        columns,
        data: datos,
        enableExpanding: true,
        renderEmptyRowsFallback: () => (
            <p class="MuiTypography-root MuiTypography-body1 css-1bl6rhr-MuiTypography-root">
                SIN REGISTROS DISPONIBLES
            </p>
        ),
        muiTableBodyRowProps: ({ row, table }) => ({
            onClick: () => {
                const expanded = row.getIsExpanded();
                table.setExpanded({ [row.id]: !expanded });
            },
            sx: { cursor: 'pointer' },
        }),
        state: {
            isLoading: loadingData,
            showProgressBars: loadingData,
            isSaving: loadingData,
        },
        muiExpandButtonProps: ({ row, table }) => ({
            onClick: () => table.setExpanded({ [row.id]: !row.getIsExpanded() }),
            sx: {
                transform: row.getIsExpanded() ? 'rotate(180deg)' : 'rotate(-90deg)',
                transition: 'transform 0.2s',
            },
        }),
        renderDetailPanel: ({ row }) =>
            (row.original.user ?? row.original.User) ?  (
                <div className='w-full flex items-center justify-center'>
                    <SvgPanel className="w-full max-w-[50%] max-[800px]:max-w-[30rem] min-[1100px]:max-w-[40%]" dataArray={formatCreateP10(row.original)} />
                </div>
            ) : null,
    });

    return <MaterialReactTable table={table} />;
}
